import devaPriyakumar from "../../assets/faculty/team faculty/2.webp";
import CVJ from "../../assets/faculty/CVJ.webp";
import rameshLoganathan from "../../assets/faculty/ramesh.webp";
import vikramPudi from "../../assets/faculty/team faculty/1.webp";
import bapiRaju from "../../assets/faculty/team faculty/4.webp";
import CKRaju from "../../assets/faculty/team faculty/3.webp";
import gopalaKrishnan from "../../assets/faculty/team faculty/5.webp";
import Ashutosh from "../../assets/faculty/team faculty/AshutoshSir.webp";
import Ganesh from "../../assets/faculty/team faculty/GaneshSir.webp";
import Jay from "../../assets/faculty/Jay.webp";

const facData = [
    {
        "ani": "fade-right",
        "img": devaPriyakumar,
        "name": "U. Deva Priyakumar",
        "details": "Academic Head, IHub-Data, Member Secretary, Professor Ph.D (Pondicherry University)"
    },
    {
        "ani": "fade-left",
        "img": Jay,
        "name": "Jay Mookherje",
        "details": "CEO, IHub-Data, Adjunct Faculty- IIITH, PhD (Florida International University)"
    },
    {
        "ani": "fade-left",
        "img": Ashutosh,
        "name": "Ashutosh Kumar",
        "details": "COO, IHub - Data"
    },
    {
        "ani": "fade-right",
        "img": Ganesh,
        "name": "Veera Ganesh Yalla",
        "details": "CTO, IHub-Data, Adjunct Faculty- IIITH, PhD (University of Kentucky)"
    },
    // {
    //     "ani": "fade-right",
    //     "img": sVerma,
    //     "name": "Varma S. Konala",
    //     "details": "CEO, INAI"
    // },
    {
        "ani": "fade-right",
        "img": bapiRaju,
        "name": "Bapi Raju",
        "details": "Head Healthcare"
    },
    {
        "ani": "fade-left",
        "img": CVJ,
        "name": "C.V. Jawahar",
        "details": "Head Mobility"
    },
    {
        "ani": "fade-left",
        "img": vikramPudi,
        "name": "Vikram Pudi",
        "details": "Head Data Foundation"
    },
    {
        "ani": "fade-right",
        "img": rameshLoganathan,
        "name": "Ramesh Loganathan",
        "details": "Head Startups & Innovation, Professor of Practice, Co-innovations M.E (Anna University, Guindy)"
    },
    {
        "ani": "fade-left",
        "img": CKRaju,
        "name": "C.K. Raju",
        "details": "Head Programs"
    },
    {
        "ani": "fade-left",
        "img": gopalaKrishnan,
        "name": "B Gopalakrishnan",
        "details": "Scientific Operations"
    }
];

export default facData;
